import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=7b828d24&"
import script from "./Billboard.vue?vue&type=script&lang=ts&"
export * from "./Billboard.vue?vue&type=script&lang=ts&"
import style0 from "./Scorecard.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports